/*
 * Name        : DFA Woo Sidebar
 * Version     : 0.3.1
 * Author      : Deep Fried Advertising
 * Author URL  : https://deepfriedads.com
 * Description : Adds event listeners to add to cart, if more than 3 items hides list in sidebar
*/

import { $, $html, $menu_button } from './_var';



// const $atcButton = $('.add_to_cart_button');
// const $atcButtonSingle = $('.single_add_to_cart_button');
// const $rfcButton = $('.remove_from_cart_button');

const woo_sidebar = function()
{
	// var $wooLink   = $('a[data-product_id]');
	// var $cartList = $('.woocommerce-mini-cart li');
	//
	// $wooLink.on('click', function()
	// {
	// 	var test = $cartList.length;
	// 	console.log(test);
	//
	//
	// });



};

export { woo_sidebar };
